<template>
  <div class="app-container">
    <list ref="list" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/cashier/balanceflow/list";

export default {
  name: "balanceflow",
  mixins: [curdMixins],
  components: {
    list,
  },
  mounted() {},
  methods: {},
};
</script>